import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Chart } from 'primereact/chart';
import { BreadCrumb } from 'primereact/breadcrumb';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { send, notify } from "../../../services/NotificationService";
import { InputText } from "primereact/inputtext";
import { classNames } from 'primereact/utils';
import { useFormik } from 'formik';
import { Accordion, AccordionTab } from 'primereact/accordion';

import 'moment/locale/fr';
import Moment from 'react-moment';
import {
    useLoaderData,
    Form,
    useFetcher,
    useSubmit
} from "react-router-dom";
import { getSource, updateFavorite, runDcaBuy, getStats, getStatsSettings, getLogs, activeOrNot, hideOrShowConfidentialsData, putStatsSettings } from "../../../data/money/sources";
export async function action({ request, params }) {
    let formData = await request.formData();
    return updateFavorite(params.sourceId, {
        favorite: formData.get("favorite") === "true",
    });
}
export async function loader({ params }) {
    const source = await getSource(params.sourceId);
    if (!source) {
        throw new Response("", {
            status: 404,
            statusText: "Not Found",
        });
    }
    const buyStats = await getStats("DcaBuy", "ETHUSDC_SPBL");
    const lastRun = await getLogs("DcaBuy");
    const settings = await getStatsSettings("DcaBuy", "ETHUSDC_SPBL");

    return { source, buyStats, lastRun, settings };
}
export default function Source() {
    const { source, buyStats, lastRun, settings } = useLoaderData();
    const [chartBuyData, setChartBuyData] = useState({});
    

    const [chartBuyMonthsData, setChartBuyMonthsData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

        var buyLbls = [];
        var buyValuesAccu = [];
        var buyValuesAccuInUsd = [];
        var v = 0;
        var vBtc = 0;
        var buyValues = [];
        var buyValuesInUsd = [];


        //maps
        buyStats.allItems.map((item) => {
            v += item.sumIncrease;
            vBtc += item.sumAmount;
            buyLbls.push(item.label);
            buyValuesAccu.push(v);
            buyValuesAccuInUsd.push(vBtc);
            buyValues.push(item.sumIncrease);
            buyValuesInUsd.push(item.sumAmount);
        });

        const buyData = {
            
            labels: buyLbls,
            datasets: [
                {
                    type: 'line',
                    label: 'Progression cumulée en %',
                    borderColor: documentStyle.getPropertyValue('--blue-500'),
                    borderWidth: 2,
                    yAxisID: 'y',
                    fill: false,
                    tension: 0.4,
                    data: buyValuesAccu
                },
                {
                    type: 'bar',
                    label: '%/trade',
                    yAxisID: 'y',
                    backgroundColor: documentStyle.getPropertyValue('--blue-500'),
                    data: buyValues,
                    borderColor: 'white',
                    borderWidth: 2
                }
                
            ]
        };

        if (buyStats.isConfidential === false) {

            buyData.datasets.push({
                type: 'line',
                label: 'Progression cumulée en USD',
                borderColor: documentStyle.getPropertyValue('--green-500'),
                borderWidth: 2,
                yAxisID: 'y1',
                fill: false,
                tension: 0.4,
                data: buyValuesAccuInUsd
            });

            buyData.datasets.push({
                type: 'bar',
                label: 'USD/trade',
                yAxisID: 'y1',
                backgroundColor: documentStyle.getPropertyValue('--green-500'),
                data: buyValuesInUsd,
                borderColor: 'white',
                borderWidth: 2
            });
        }


        const buyMonthsLbls = [];
        var buyMonthsValuesAccu = [];   
        var buyMonthsValuesAccuInUsd = [];
        var vMonths = 0;
        var vMonthsBtc = 0;
        var buyMonthsValues = [];
        var buyMonthsValuesInUsd = [];

        buyStats.itemsByMonth.map((item) => {
            vMonths += item.sumIncrease;
            vMonthsBtc += item.sumAmount;
            buyMonthsLbls.push(item.label);
            buyMonthsValuesAccu.push(vMonths);
            buyMonthsValuesAccuInUsd.push(vMonthsBtc);
            buyMonthsValues.push(item.sumIncrease);
            buyMonthsValuesInUsd.push(item.sumAmount);
        });

        const buyMonthsData = {
            labels: buyMonthsLbls,
            datasets: [
                {
                    type: 'line',
                    label: 'Progression cumulée en %',
                    borderColor: documentStyle.getPropertyValue('--blue-500'),
                    borderWidth: 2,
                    yAxisID: 'y',
                    fill: false,
                    tension: 0.4,
                    data: buyMonthsValuesAccu
                },
                {
                    type: 'bar',
                    label: '%/trade',
                    yAxisID: 'y',
                    backgroundColor: documentStyle.getPropertyValue('--blue-500'),
                    data: buyMonthsValues,
                    borderColor: 'white',
                    borderWidth: 2
                }
            ]
        };

        if (buyStats.isConfidential === false) {
            buyMonthsData.datasets.push(
                {
                    type: 'line',
                    label: 'Progression cumulée en USD',
                    borderColor: documentStyle.getPropertyValue('--green-500'),
                    borderWidth: 2,
                    yAxisID: 'y1',
                    fill: false,
                    tension: 0.4,
                    data: buyMonthsValuesAccuInUsd
                },
            );

            buyMonthsData.datasets.push(
                {
                    type: 'bar',
                    label: 'USD/trade',
                    yAxisID: 'y1',
                    backgroundColor: documentStyle.getPropertyValue('--green-500'),
                    data: buyMonthsValuesInUsd,
                    borderColor: 'white',
                    borderWidth: 2
                }
            );

        }
                        


        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.6,
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                },
                y: {
                    type: 'linear',
                    display: true,
                    position: 'left',
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                },
                y1: {
                    type: 'linear',
                    display: true,
                    position: 'right',
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        drawOnChartArea: false,
                        color: surfaceBorder
                    }
                }
            }
        };
        setChartBuyMonthsData(buyMonthsData);

        setChartBuyData(buyData);
        setChartOptions(options);
    }, []);

    const items = [
        {
            label: source.name,
            template: () => <span>{source.name}</span>
        }
    ];
    const home = { icon: 'pi pi-home', url: '/' };

    const submit = useSubmit();
    const accept = () => {
        submit(null, { method: "post", action: "delete" })
    };

    const switchHideConfidentialsData = () => {
        var ret = hideOrShowConfidentialsData(buyStats.id);
        ret.then((res) => {
            if (res.status === 200) {
                send("success", res.message);
                // reload the page to get the new status
                window.location.reload();
                notify();
            } else {
                send("error", res.message);
                notify();
            }
        });
    };


    const acceptPauseStop = () => {
        var ret = activeOrNot(buyStats.id);
        ret.then((res) => {
            if (res.status === 200) {
                send("success", res.message);
                // reload the page to get the new status
                window.location.reload();
                notify();
            } else {
                send("error", res.message);
                notify();
            }
        });
    };
    
    const reject = () => {
    };

    const deleteSource = (event) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Êtes-vous sûr de vouloir supprimer cette source ?',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Oui',
            rejectLabel: 'Non',
            accept,
            reject
        });
    };
    const switchPauseStop = (event) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Êtes-vous sûr  ?',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Oui',
            rejectLabel: 'Non',
            accept: () => { acceptPauseStop(); },
            reject
        });
    };
    

    const runDcaBuyOnBitget = (event) => {
        // message different en fonction de la valeur du prix
        var message = 'Êtes-vous sûr de vouloir excecuter le DCA ?';
        if (formik.values.buyprice <=0) {
            message = 'Êtes-vous sûr de vouloir forcer l\'arrêt du robot ?';
            }
        confirmPopup({
            target: event.currentTarget,
            message: message,
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Oui',
            rejectLabel: 'Non',
            accept: () => { acceptDcaBuy(); },
            reject
        });
    };

    const updateStartCapital = () => {
        var startCapital = formik.values.startCapital;
        var r = putStatsSettings("DcaBuy", "ETHUSDC_SPBL",  startCapital );
        r.then((ret) => {
            if (ret.status === 200) {
                send("success", ret.message)
                notify();
            } else {
                send("error", ret.message)
                notify();
            }
        });
    };
    const acceptDcaBuy = () => {
        var price = formik.values.buyprice;
        var r = runDcaBuy(source.publicId, price);
        r.then((ret) => {
            if (ret.status === 200) {
                send("success", ret.message)
                notify();
            }

        });
    };



    // Formik ---------------------

    const formik = useFormik({
        initialValues: {
            buyprice: 0.0,
            sellprice: 0.0,
            sellEthprice: 0.0,
            startCapital: (settings && settings.startCapital) || 0.0
        },
        validate: (data) => {
            let errors = {};

            if (!data.price) {
                errors.price = 'price is required.';
            }
            // start capital must be a number and greater than 0
            if (!data.startCapital || isNaN(data.startCapital) || data.startCapital <= 0) {
                errors.startCapital = 'Le capital de départ doit être un nombre supérieur à 0.';
            }

           

            return errors;
        }
    });

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);


    //----------------------------------------

    const calendarStrings = {
        lastDay: '[Hier à] HH:mm',
        sameDay: '[Aujourd\'hui à] HH:mm',
        nextDay: '[Demain] HH:mm',
        lastWeek: 'dddd [dernier] [à] HH:mm',
        nextWeek: 'dddd HH:mm',
        sameElse: 'L'
    };


    return (
        <div>
            <BreadCrumb model={items} home={home} />
        <div id="thumbnail">
            <div>
                <img height="192" key={source.publicId} alt={source.name} src={source.base64Picture || null} />
            </div>

            <div>
                <h1>
                    {source.name ? (
                        <>
                            {source.name}
                        </>
                    ) : (
                        <i>Inconnu</i>
                    )}{" "}
                    <Favorite source={source} />
                </h1>

                {source.link && (
                    <p>
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href={source.link}
                        >
                            {source.link}
                        </a>
                    </p>
                )}


                <div>
                        <Form action="edit">
                            <Button type="submit" size="small">Modifier</Button>
                    </Form>
                    <Form action="assets/create">
                            <Button type="submit" size="small">Créer un actif</Button>
                    </Form>
                        <ConfirmPopup />
                        <Button onClick={deleteSource} icon="pi pi-trash" label="" size="small" className="p-button-danger"></Button>

                        
                        
                </div>

            </div>

            </div>


            <div id="mainContent">
                <h2>
                    {(buyStats.isActive) ? (<Button onClick={switchPauseStop} icon="pi pi-pause" label="" size="small" severity="secondary"></Button>)
                        : <Button onClick={switchPauseStop} icon="pi pi-play" label="" size="small" severity="secondary"></Button>
                    }

                    {(buyStats.isConfidential) ? (
                        <Button onClick={switchHideConfidentialsData} icon="pi pi-eye" label="" size="small" severity="secondary"></Button>
                    ) :
                        (
                            <Button onClick={switchHideConfidentialsData}  icon="pi pi-eye-slash" label="" size="small" severity="secondary"></Button>
                        )}

                    ETH : Achat DCA sur {buyStats.exchange}

                   
                </h2>

                {(buyStats.isMasterAccount) && (
                    <span className="p-float-label">
                        <InputText id="buyprice" name="buyprice" value={formik.values.buyprice}
                            keyfilter="num"
                            onChange={(e) => {
                                formik.setFieldValue('buyprice', e.target.value);
                            }}
                            className={classNames({ 'p-invalid': isFormFieldInvalid('buyprice') })}
                        />

                        <label htmlFor="buyprice">Prix d'achat (ETHUSDC)</label>
                        <Button onClick={runDcaBuyOnBitget} icon="pi pi-play" label="" size="small" ></Button>

                    </span>
                )}

                {(buyStats.isRunning) ? (
                    <p className="p-float-label">Statut : <i>Trade actuellement en cours...</i></p>

                ) :
                    (<p className="p-float-label">Statut: <i>En attente...</i></p>)}
                <Accordion {...(buyStats.isConfidential === false && { activeIndex: 0 })}  >
                    <AccordionTab header="Paramètres" {...(buyStats.isConfidential === true && { disabled: true })} >
                        <p className="m-0">
                            <span className="p-float-label">
                                <InputText id="startCapital" name="startCapital" value={formik.values.startCapital}
                                    keyfilter="num"
                                    onChange={(e) => {
                                        formik.setFieldValue('startCapital', e.target.value);
                                    }}
                                    className={classNames({ 'p-invalid': isFormFieldInvalid('startCapital') })}
                                />

                                <label htmlFor="startCapital">Capital de départ</label>
                                <Button onClick={updateStartCapital} icon="pi pi-check" label="" size="small" ></Button>
                                {(settings) &&
                                    <small><i> (Dispo : {settings.avalaibleCapital})</i></small>
                                }
                            </span>
                        </p>
                    </AccordionTab>
                    <AccordionTab header="Logs"  {...(buyStats.isConfidential === true && { disabled:true})}  >
                         
                        <code>
                            {lastRun && lastRun.length === 0 && <p>Aucun trade</p>}
                            {lastRun && lastRun.length > 0 &&
                                <ul>
                                    {lastRun.map((item, index) => (
                                        <li key={index}>
                                            {(item.date) && (
                                                <>
                                                    <Moment locale="fr" calendar={calendarStrings}>
                                                        {new Date(item.date)}
                                                    </Moment> :
                                                </>
                                            )}


                                            {item.message}
                                        </li>
                                    ))}
                                </ul>
                            }
                        </code>
                       
                    </AccordionTab>
                </Accordion>
             

                <h3>Par mois</h3>
                <Chart type="line" data={chartBuyMonthsData} options={chartOptions} style={{ position: 'relative', width: '97%' }} />
                <h3>Trades sur 90 jours glissants</h3>
                <Chart type="line" data={chartBuyData} options={chartOptions} style={{ position: 'relative', width: '97%' }} />
              
            </div>

    </div>
    );
}

function Favorite({ source }) {
    const fetcher = useFetcher();
    // yes, this is a `let` for later
    let favorite = source.isFavorite;
    if (fetcher.formData) {
        favorite = fetcher.formData.get("favorite") === "true";
    }
    return (
        <fetcher.Form method="post">
            <button
                name="favorite"
                value={favorite ? "false" : "true"}
                aria-label={
                    favorite
                        ? "Remove from favorites"
                        : "Add to favorites"
                }
            >
                {favorite ? "★" : "☆"}
            </button>
        </fetcher.Form>
    );
}